import { useMutation } from '@tanstack/react-query';

import OpenNotification from 'src/app/components/antd/OpenNotification';

import { apiCancellationFunnels } from '../../api';
import { releaseReponseFactory } from '../../utils/releaseFunnelsPageFactory';

export function useTryToRequestReleasePage() {
  const { mutateAsync } = useMutation({
    mutationFn: async (id: string) => {
      const response =
        await apiCancellationFunnels.tryToRequestGetOneCancellationFunnelPage(
          id
        );

      const factory = releaseReponseFactory(response.data);

      return factory;
    },
    onError: () => {
      OpenNotification(
        true,
        'Erro ao solicitar dados de Lançamento',
        'Ocorreu um erro ao solicitar dados de Lançamento, por favor tente novamente mais tarde.'
      );
    },
  });

  return {
    tryToRequestReleasePage: mutateAsync,
  };
}
